import * as React from 'react';
import NDate from '@nepo/ndate';

import '../DatePicker.scss';

const createYearsList = () => {
  const result = [];
  const yaerStart = new NDate().yearJalali + 10;
  for (let i = yaerStart; i >= 1300; i--) {
    result.push(i);
  }

  return result;
};

const YearBlock = props => {
  return (
    <div className="yearBlock">
      {createYearsList().map(year => {
        return (
          <p className="year" key={year} onClick={() => props.onYearClick(year)}>
            {year}
          </p>
        );
      })}
    </div>
  );
};

export default YearBlock;
